import { pricesURL, dashboardURL } from '@lessonnine/babbel-urls.js';

import { getReturnToUrl } from 'src/dataLayer/localData/queryParams/returnToURLHelpers';
import { getLivePricePageURL } from 'src/dataLayer/env';
import { UserInputType } from '../types.common';

const getUrlFromEmailVerificationTarget = (emailVerificationTarget: string): string => {
  const emailVerificationTargetMapping: {[key: string]: () => string} = {
    dashboard: dashboardURL,
    plans_live: getLivePricePageURL
  };
  return emailVerificationTargetMapping[emailVerificationTarget]();
};

interface GetPostVerificationRedirectParams {
  userInput: Partial<UserInputType>,
  learnLang: string,
  emailVerificationTarget?: string,
  flowId?: string,
}

export const getPostVerificationRedirect = ({
  learnLang,
  emailVerificationTarget
}: GetPostVerificationRedirectParams): string => {
  // if there is a return_to url in query params it should take priority over other options
  // we need the second argument to be null, otherwise getReturnToUrl will return the fallback url
  // eslint-disable-next-line unicorn/no-null
  const returnToUrlFromQueryParams = getReturnToUrl(window.location.search, null);

  if (returnToUrlFromQueryParams) return returnToUrlFromQueryParams;

  // email link can be configured via return_to query parameter or set to a url in flow options config
  // defaults to pricesURL e.g. de.babbel.cn/preise/<learn_language>
  if (emailVerificationTarget)
    return getUrlFromEmailVerificationTarget(emailVerificationTarget);

  return pricesURL(learnLang);
};
